<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{ inpe.inpe_email }} from the sales partner {{inpe.inpt_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmInpe">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      inpe_encrid: null,
      inpe: {}
    }
  },
  methods: {
    open(inpe_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/inpt/inpe/getInpe.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getInpe"
          },
          getInpe: {
            inpe_encrid: inpe_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.inpe = res.data.getInpe;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmInpe() { 
      this.$axios
        .post("ares/json/ares/task/inpt/inpe/rmInpe.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmInpe"
          },
          rmInpe: {
            inpe_encrid: this.inpe.inpe_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             if (res.data.rmInpe.color == "success") { 
                setTimeout(() => { this.$router.reload('/task/inpt/onInpt/' + res.data.rmInpe.inpt_encrid);  }, 2000);      
             }   
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmInpe.text,
              color: res.data.rmInpe.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

